package one.healthium.domain.common

enum class FoodUnit {
    Gram,
    Ml,
    Oz,
    FlOz,
    Cup,
    Tablespoon,
    Teaspoon,
    Piece,
    Portion,
}